import { IAddressesState } from './types';

export const SLICE_NAMESPACE = 'auth';

export const addressesInitialState: IAddressesState = {
  addresses: [],
  loading: true,
  error: null,
};
